import { render } from "./ContactSectionNew.vue?vue&type=template&id=31c4e5e7&scoped=true"
import script from "./ContactSectionNew.vue?vue&type=script&lang=js"
export * from "./ContactSectionNew.vue?vue&type=script&lang=js"

import "./ContactSectionNew.vue?vue&type=style&index=0&id=31c4e5e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c4e5e7"]])

export default __exports__